module.exports = __webpack_public_path__ + "static/media/CCSC-Logo.6273dfff.svg";